
import React from 'react'

const REVIEW_TITLE_TEXT = 'Give your review a title'
const REVIEW_TEXT = 'Write your comments here'
const NAME_TEXT = 'Enter your name (public)'
const EMAIL_TEXT = 'Enter your email (private)'

const ReviewForm = ({ formData, handleInputChange, isEmailValid }) => {
  return (
    <div className='review-form-container'>

      <div className='jdgm-form__fieldset'>
        <label
          className='jdgm-form__inline-label'
          htmlFor='review_title'
        >
          Review Title
        </label>
        <input
          id='review_title'
          name='review_title'
          type='text'
          value={formData.review_title}
          onChange={handleInputChange}
          placeholder={REVIEW_TITLE_TEXT}
          aria-label='Review Title'
          className='review-input-field'
        />
      </div>

      <div className='jdgm-form__fieldset'>
        <label
          className='jdgm-form__inline-label'
          htmlFor='review_body'
        >
          Review
        </label>
        <textarea
          id='review_body'
          name='review_body'
          value={formData.review_body}
          onChange={handleInputChange}
          placeholder={REVIEW_TEXT}
          aria-label='Review Body'
          className='review-input-field'
          rows='5'
        />
      </div>

      <div className='jdgm-form__fieldset'>
        <label
          className='jdgm-form__inline-label'
          htmlFor='reviewer_name'
        >
          Name
        </label>
        <input
          id='reviewer_name'
          name='reviewer_name'
          type='text'
          value={formData.reviewer_name}
          onChange={handleInputChange}
          placeholder={NAME_TEXT}
          aria-label='Reviewer Name'
          className='review-input-field'
        />
      </div>

      <div className='jdgm-form__fieldset'>
        <label
          className='jdgm-form__inline-label'
          htmlFor='reviewer_email'
        >
          Email
        </label>
        <input
          id='reviewer_email'
          name='reviewer_email'
          type='email'
          value={formData.reviewer_email}
          onChange={handleInputChange}
          placeholder={EMAIL_TEXT}
          aria-label='Reviewer Email'
          className={`review-input-field ${!isEmailValid ? 'review-input-field--error' : ''}`}
        />
      </div>
    </div>
  )
}

export default ReviewForm
